import React from 'react';
import { Text } from '@miro-site/core';
import { jsx as _jsx } from "react/jsx-runtime";

var Description = function Description(props) {
  return /*#__PURE__*/_jsx(Text, {
    $variant: ['p1', 'p0', 'p0', 'p0'],
    $styles: {
      maxWidth: [null, 599, 599, 599],
      opacity: 'var(--wcds-legacy-paragraph-opacity)' // to be removed when VIS is the default theme

    },
    $mx: "auto",
    $align: "center",
    children: props.children
  });
};

export default Description;